import { React, useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import "./header.scss";
import { ParentNav } from "./headerStyle";
import ConsultaNominas from "../../../components/molecules/modals/consultaNominas/ConsultaNominas";
import ConsultaIRPF from "../../../components/molecules/modals/consultaIRPF/ConsultaIRPF";
import "../../molecules/cards/card.scss";
import { getUrlAlcantara } from "../../services/IndemnizacionService";
import ModalMensajes from "../modals/modalMensajes/ModalMensajes";
import { logout } from "../../services/LoginService";
import { useLocalStorage } from "../../../hooks/useLocalStorage";

import ConstantesBD from "../../../utils/ConstantesBD";

import ConsultaIRPFHabi from "../modals/consultaIRPFHabi/ConsultaIRPFHabi";

import { visualizarSeccionConcursos } from "../../services/ConcursosService";

const NavBar = ({ open, handleOpen }) => {
  const navigate = useNavigate()
  const [user] = useLocalStorage("user", "");
  const [concursosVisible, setConcursosVisible] = useState(false);

  // const [INFOEX_habilitado, setINFOEX_Habilitado] = useState(false);
  // const [IRPFHABILITACIONES_habilitado, setIRPFHABILITACIONES_Habilitado] =
  //   useState({ habilitado: null });
  // const [adquisicion_habilitado, setAdquisicion_habilitado] = useState(false);
  const [showFeedback] = useState(false);

  const [show, setShow] = useState({
    nomina: false,
    irpf: false,
    irpfhabi: false
  });

  const handleShow = (e) => {
    setShow(e);
  };
  const handleClose = (e) => {
    setShow(false);
  };
  const indemnizacion = () => {
    getUrlAlcantara().then((data) => {
      if (!data.toString().startsWith("Error")) {
        if (data.url !== null) {
          window.open(data.url);
        }
      } else {
        handleShow({
          mensaje: true,
          titulo: "Enlace no disponible para acceder al sistema de Alcantara",
          tipo: "tituloBorrador",
        });
      }
    });
    handleOpen()
  };

  // const certificacion = () => {
  //   getPDF().then((data) => { //INFOEX PDF
  //     if (!data.toString().startsWith("Error:")) {
  //       window.open(data.url);
  //     } else {
  //       setShowFeedback(true);
  //     }
  //   });
  //   handleOpen()
  // };

  useEffect(() => {
    // esHabilitado().then((data) => {
    //   if (data !== undefined) {
    //     setINFOEX_Habilitado(data.habilitado);
    //   }
    // });
    // getDataAdqusicion().then((data) => {
    //   if (data !== undefined) {
    //     setAdquisicion_habilitado(data.mostrarSeccion);
    //     localStorage.setItem("dataAdquisicion", JSON.stringify(data));
    //   }
    // });
    // if (localStorage.getItem("dataIrpfHabiliciones") === null) {
    //   irpfHabilitado().then((data) => {
    //     if (!data.toString().startsWith("Error:")) {
    //       setIRPFHABILITACIONES_Habilitado(data);
    //       localStorage.setItem("dataIrpfHabiliciones", JSON.stringify(data));
    //     } else {
    //       // setError_IRPFHABILITACIONES(true);
    //     }
    //   });
    // } else {
    //   setIRPFHABILITACIONES_Habilitado({
    //     habilitado: JSON.parse(localStorage.getItem("dataIrpfHabiliciones")).habilitado,
    //   });
    // }
  }, []);

  useEffect(() => {
    if (user) {
      visualizarSeccionConcursos().then((data) => {
        setConcursosVisible(data);
      })
    }

  }, [user]);

  return (
    <>
      <ParentNav open={open} aria-hidden={!open} style={{ pointerEvents: open ? "auto" : "none" }}>
        <ul
          className="justify-content-center scroll-list"
          style={{ paddingLeft: "1rem " }}
        >
          <li className="icono-cerrar" onClick={() => handleOpen()}
            role="button"
            title="Cerrar menú lateral"
            aria-label="Cerrar menú lateral"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Escape" || e.key === "Enter" || e.key === " ") {
                handleOpen();
              }
            }}>
            <i className="fa fa-close fs-1 cursor cursorPointer"></i>
          </li>
          {user === null || user === undefined ? null : (<>
            <li className="card nombre-usuario d-flex align-items-center">
              <p className="text-center mb-1">
                {user?.nombre !== undefined ? (
                  <>
                    {`${user?.nombre} ${user?.apellido2 === undefined || user?.apellido2 === null || user?.apellido2 === ""
                      ? user?.apellido1
                      : `${user?.apellido1} ${user?.apellido2}`
                      }`}
                  </>
                ) : null}
                <i className="caret" aria-hidden="true"></i>
              </p>
            </li>
          </>)}


          <ul
            className="perfilBotones"
            style={{
              textAlign: "center",
              borderBottom: "4px solid #1d873e",
              paddingBlockStart: "0px",
              margin: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <li className="d-flex">
              {/* OCULTO EN EL MENÚ SI NO HAY USUARIO */}
              {user === null || user === undefined ? null : (<>
                <Link to="/detallePersonal" className="hover" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                  VER PERFIL
                </Link>{" "}
                <span className="text-paragraph-big"> | </span>
              </>)}

              <div
                className="fs-6 cursorPointer"
                onClick={() => {
                  // setShow({
                  //   aviso: true,
                  //   mensaje: true,
                  //   titulo: user === null || user === undefined ? "¿Deseas volver a iniciar sesión?" : "¿Deseas cerrar sesión?",
                  //   tipo: "tituloModal",
                  //   destinoAviso: "/login",
                  //   funcion: logout,
                  //   destinoCerrar: null
                  // });
                  // handleOpen();
                  logout()
                  navigate("/login")
                }}
                role="link"
                title={user === null || user === undefined ? "Acceder" : "Cerrar sesión"}
                aria-label="Enlace para cerrar sesión"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    // setShow({
                    //   aviso: true,
                    //   mensaje: true,
                    //   titulo: user === null || user === undefined ? "¿Deseas volver a iniciar de sesión?" : "¿Deseas cerrar sesión?",
                    //   tipo: "tituloModal",
                    //   destinoAviso: "/login",
                    //   funcion: logout,
                    //   destinoCerrar: null
                    // });
                    
                    // handleOpen();
                    logout()
                    navigate("/login")
                    
                  }
                }}
              >
                <strong className="salir">{user === null || user === undefined ? "ACCEDER" : "SALIR"}</strong>
              </div>
            </li>
          </ul>

          {/* OCULTO EN EL MENÚ SI NO HAY USUARIO */}
          {user === null || user === undefined ? null : (<>
            <li>
              <Link className=" hover" to="/home" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                INICIO
              </Link>
            </li>
            {window.location.pathname !== "/" &&
              window.location.pathname !== "/login" &&
              window.location.pathname !== "/loginCredenciales" ? (<>

                {user?.roles.includes(ConstantesBD.ROLES.ADMINISTRADOR) ? (
                  <li className="">
                    <label id="drop-gestion" className="toggle">
                      <strong className="text-principal-1">
                        GESTIÓN &nbsp;&nbsp;
                        <i className="caret" aria-hidden="true"></i>
                      </strong>
                    </label>
                    <ul className="">
                      <li>
                        <Link className=" hover" to="/admin" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                          ADMINISTRACIÓN
                        </Link>
                      </li>
                    </ul>
                  </li>
                ) : null}


              </>) : null}


            <li>
              <label id="drop-2" className="toggle">
                <strong className="text-principal-1">
                  Mis consultas &nbsp;&nbsp;
                  <i className="caret" aria-hidden="true"></i>
                </strong>
              </label>

              <ul className="">
                <li className="sub-menu">
                  <Link
                    className=" hover"
                    to="#"
                    onClick={() => {
                      handleShow({ nomina: true })
                      handleOpen()
                    }}
                    tabIndex={open ? "0" : "-1"}
                  >
                    Nómina
                  </Link>
                </li>
                <li className="sub-menu">
                  <Link
                    className=" hover"
                    to="#"
                    onClick={() => {
                      handleShow({ irpf: true })
                      handleOpen()
                    }}
                  >
                    IRPF
                  </Link>
                </li>

                <li className="sub-menu">
                  <Link className=" hover" to="#" onClick={() => {
                    handleShow({ irpfhabi: true })
                    handleOpen()
                  }} tabIndex={open ? "0" : "-1"}>
                    Certificado IRPF por las habilitaciones
                  </Link>
                </li>

                <li className="sub-menu">
                  <Link className=" hover" to="/misActosAdmin" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                    Consulta de mis actos administrativos
                  </Link>
                </li>

                {/*   <li className="sub-menu">
                <Link className=" hover" to="/hojaServiciosPrestados" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                  Mi hoja de servicios prestados
                </Link>
              </li>*/}
              </ul>
            </li>

            <li>
              <label id="drop-tramites" className="toggle">
                <strong className="text-principal-1">
                  Mis trámites &nbsp;&nbsp;
                  <i className="caret" aria-hidden="true"></i>
                </strong>
              </label>

              <ul className="">
                <li className="sub-menu">
                  <Link className=" hover" to="#" onClick={indemnizacion} tabIndex={open ? "0" : "-1"}>
                    C.S Indemnización razón servicio D.42/2025
                  </Link>
                </li>

                {/* {adquisicion_habilitado ? (
                <li className="sub-menu">
                  <Link className=" hover" to="/adquisicion">
                    Adquisición Especialidad Empleo A1-A2
                  </Link>
                </li>
              ) : null} */}

                {/* {INFOEX_habilitado ? (
                // <>
                //   <li className="sub-menu">
                //     <Link className="hover" to="#" onClick={certificacion} tabIndex={open ? "0" : "-1"}>
                //       Certificación INFOEX
                //     </Link>
                //   </li>
                // </>
              // ) : null} */}
                <li className="sub-menu">
                  <Link className=" hover" to="/listadoactos" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                    Trámites
                  </Link>
                </li>
              </ul>

            </li>
            {concursosVisible ? (
              <li>
                <label id="drop-convocatorias" className="toggle">
                  <strong className="text-principal-1">
                    Mis Convocatorias &nbsp;&nbsp;
                    <i className="caret" aria-hidden="true"></i>
                  </strong>
                </label>
                <ul className="">
                  <li className="sub-menu">
                    <Link className=" hover" to="/concursos" onClick={() => handleOpen()} tabIndex={open ? "0" : "-1"}>
                      Concursos de traslado
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}



          </>)}

          {/* <li>
            <label id="drop-3" className="toggle">
              <strong className="text-principal-1">
                Actos administrativos &nbsp;&nbsp;
                <i className="caret" aria-hidden="true"></i>
              </strong>
            </label>
            <ul className="">
              

            </ul>
          </li> */}
        </ul>
      </ParentNav>
      {show.nomina ? (
        <ConsultaNominas
          show={show}
          handleClose={handleClose}
        ></ConsultaNominas>
      ) : null}
      {show.irpf ? (
        <ConsultaIRPF show={show} handleClose={handleClose}></ConsultaIRPF>
      ) : null}
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          texto={show.titulo}
          aviso={show?.aviso}
          tipo={show?.tipo}
          destinoAviso={show?.destinoAviso}
          funcion={show.funcion}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
      {showFeedback ? (
        <>
          <ModalMensajes
            show={show.mensaje}
            handleClose={handleClose}
            titulo="Error al recuperar el PDF"
            tipo="tituloBorrador rojo"
            destinoCerrar={show?.destinoCerrar}
          ></ModalMensajes>
        </>
      ) : null}
      {show.irpfhabi ? (
        <ConsultaIRPFHabi show={show} handleClose={handleClose}></ConsultaIRPFHabi>
      ) : null}
    </>
  );
};

export default NavBar;
